export const LEAD_SOURCE_TYPES = [
  { value: 'INBOUND', label: 'Site Rocket' },
  { value: 'INDICACAO', label: 'Indicação direta' },
  { value: 'EVENTO', label: 'Parceiros / evento' },
  { value: 'LINKEDIN', label: 'Lista' },
  { value: 'REATIVACAO', label: 'Agência / plataforma / indicador' },
  { value: 'OUTROS', label: 'Manual' },
] as const

export type LeadSourceTypeValue = (typeof LEAD_SOURCE_TYPES)[number]['value']

const TYPE_LABELS = Object.fromEntries(
  LEAD_SOURCE_TYPES.map((item) => [item.value, item.label]),
) as Record<LeadSourceTypeValue, string>

export function getLeadSourceTypeLabel(type: string): string {
  return TYPE_LABELS[type as LeadSourceTypeValue] ?? type
}

export type LeadSourceFormValues = {
  name: string
  type: LeadSourceTypeValue
  description: string
  totalCost: string
  isActive: boolean
}

export const emptyLeadSourceForm = (): LeadSourceFormValues => ({
  name: '',
  type: 'OUTROS',
  description: '',
  totalCost: '',
  isActive: true,
})

export function parseLeadSourceTotalCost(raw: string): number | null {
  const normalized = raw.trim().replace(',', '.')
  if (!normalized) return null
  const value = Number(normalized)
  if (!Number.isFinite(value) || value < 0) return null
  return value
}
